import React from 'react';
import Icon from '../../../components/AppIcon';

const UserInfoCard = ({ userData }) => {
  const userFields = [
    {
      icon: 'User',
      label: 'Nombre Completo',
      value: userData?.fullName
    },
    {
      icon: 'CreditCard',
      label: 'Cédula de Identidad',
      value: userData?.cedula
    },
    {
      icon: 'Mail',
      label: 'Correo Electrónico',
      value: userData?.email
    },
    {
      icon: 'Phone',
      label: 'Teléfono',
      value: userData?.phone
    }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-luxury">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-secondary/10 rounded-lg flex items-center justify-center">
          <Icon name="UserCheck" size={20} className="text-secondary" />
        </div>
        <div>
          <h3 className="text-xl font-heading font-bold text-card-foreground">
            Información del Comprador
          </h3>
          <p className="text-sm text-muted-foreground font-caption">
            Datos registrados en la compra
          </p>
        </div>
      </div>
      <div className="space-y-4">
        {userFields?.map((field, index) => (
          <div key={index} className="flex items-center space-x-4 py-3 border-b border-border last:border-b-0">
            <div className="w-8 h-8 bg-muted/30 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={field?.icon} size={14} className="text-muted-foreground" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-muted-foreground font-body mb-1">
                {field?.label}
              </p>
              <p className="text-sm font-mono text-card-foreground truncate">
                {field?.value}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center space-x-2 text-sm">
          <Icon name="Shield" size={14} className="text-success" />
          <span className="text-success font-medium">Información verificada</span>
        </div>
        <p className="text-xs text-muted-foreground mt-1 font-caption">
          Todos los datos han sido validados correctamente
        </p>
      </div>
    </div>
  );
};

export default UserInfoCard;